import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {ArtigosFacturacao} from '../../../../shared/models/artigos/artigosfacturacao';
import {Aplicacao} from '../../../../shared/models/aplicacao/aplicacao';
import {Subscription} from 'rxjs';
import {Empresa} from '../../../../shared/models/empresa/empresa';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ArtigosService} from '../../../../shared/services/artigos/artigos.service';
import {ArtigoFiltros} from '../../../../shared/models/artigos/Filtro/artigofiltro';
import {ModalAdicionarArtigoFaComponent} from '../modal-adicionar-artigo-fa/modal-adicionar-artigo-fa.component';
import {LoginService} from 'app/shared/services/aplicacao-service/login.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'modal-pesquisa-artigos-fa',
    templateUrl: './modal-pesquisa-artigos-fa.component.html',
    styleUrls: ['./modal-pesquisa-artigos-fa.component.scss']
})
export class ModalPesquisaArtigosFaComponent implements OnInit, OnDestroy {
    opcoes = {
        P: 'Produtos',
        S: 'Serviços',
        null: 'Artigos'
    };
    checkBox = new FormControl();
    listaArtigos: ArtigosFacturacao[] = [];
    model = '';
    param;
    todosArtigos = [];
    selecionados: boolean;
    selected = [];
    checked: number;
    aplicacao: Aplicacao;
    listaDados: any[] = [];
    idIdiomaAplicacao = 1;
    activarProgresso = true;
    subscricao: Subscription[] = [];
    empresa: Empresa = {};
    activarLoader: boolean;
    tituloModal: string;
    gereStock: boolean;
    @Input() tipoArtigo = '';
    @Output() aoActivarAdicaoArtigo = new EventEmitter();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public modalRef: MatDialogRef<ModalPesquisaArtigosFaComponent>,
        private artigoService: ArtigosService,
        private loginService: LoginService,
        private modal: MatDialog
    ) {
        this.gereStock = data?.gereStock??false;
        this.tituloModal = data?.msg;
    }

    ngOnInit(): void {
        this.param = 2;
        if (this.data.artigosFA) {
            this.listaArtigos = this.data.artigosFA;
            this.listaDados = this.data.artigosFA;
        }else{
            this.getArtigos();
        }
        if (this.data.empresa) {
            this.empresa = this.data.empresa;
        }
    }

    getArtigosFacturacao() {
        let modelo = this.loginService.getUtilizadorSessao();

        this.subscricao.push(
            this.artigoService
                .getArtigosVendas(modelo)
                .subscribe((res: any) => {
                    if (res) {
                        if (this.data && this.data.tipoDocumento.codNatureza === 'P') {

                            this.listaArtigos = res.objecto.filter(
                                (x) => x.codNatureza.toUpperCase() === 'P'
                            );
                            this.listaDados = this.listaArtigos;
                        } else if (
                            this.data &&
                            this.data.tipoDocumento.codNatureza === 'S'
                        ) {
                            this.listaArtigos = res.objecto.filter(
                                (x) => x.codNatureza.toUpperCase() === 'S'
                            );
                            this.listaDados = this.listaArtigos;
                        } else {
                            this.listaArtigos = res.objecto;
                            this.listaDados = this.listaArtigos;
                        }
                    }
                })
        );
    }

    getTodosArtigos() {
        const modelo = new ArtigoFiltros(1, 'pt');
        this.artigoService.getArtigos(modelo).subscribe(
            (res) => {
                if (res) {
                    this.listaArtigos = res;
                    this.listaDados = res;
                }
            },
            (error) => {
            }
        );
    }

    getArtigos() {
        if (this.data) {
            if (this.data.tipoArtigos === 1) {
                this.getTodosArtigos();
            } else {
                this.getArtigosFacturacao();
            }
        }
    }

    confirmar(items?: any) {
        this.modalRef.close({itens: items});
    }

    adicionarItem(item: any, index?: number) {
        this.checked = null;
        this.todosArtigos = [];
        this.todosArtigos.push(item);
        this.checked = index;
    }

    selecCodigo(item?: any) {
        this.adicionarItem(item);
        this.modalRef.close({itens: this.todosArtigos, param: this.data.param});
    }

    filtrarValores(event, opcao: number) {

        const termo = event.target.value;
        let lista = [];
        setTimeout(() => {
            if (termo) {
                switch (opcao) {
                    // Filtrar codigo //
                    case 1: {
                        lista = this.listaDados.filter(
                            (x) =>
                                x.codArtigo !== null &&
                                x.codArtigo.toLowerCase().includes(termo.toLowerCase())
                        );
                        break;
                    }

                    case 2: {
                        lista = this.listaDados.filter(
                            (x) =>
                                x.tipo !== null &&
                                x.tipo.toLowerCase().includes(termo.toLowerCase())
                        );
                        break;
                    }

                    case 3: {
                        lista = this.listaDados.filter(
                            (x) => {
                                if (x.tipoArtigos === 1) {
                                    return (x?.descricao !== null && x?.descricao?.toLowerCase()?.includes(termo.toLowerCase()));
                                } else {
                                    return (x?.artigo !== null && x?.artigo?.toLowerCase()?.includes(termo.toLowerCase()));
                                }
                            }
                        );
                        break;
                    }
                    // Filtrar Estado //
                    case 4: {
                        lista = this.listaDados.filter(
                            (x) =>
                                x.estado !== null &&
                                x.estado.toLowerCase().includes(termo.toLowerCase())
                        );
                        break;
                    }
                }

                this.listaArtigos = lista;
            } else {
                this.listaArtigos = [];
                this.listaArtigos = [...this.listaDados];
            }
        }, 900);
    }

    ngOnDestroy(): void {
        if (this.subscricao.length > 0) {
            this.subscricao.forEach((sub) => {
                sub.unsubscribe();
            });
        }
    }

    adicionarNovoArtigo() {
        this.modal.open(ModalAdicionarArtigoFaComponent, {
            width: '60vw',
            maxHeight: '90vh',
            data: {
                tipoDocumento: this.data.tipoDocumento
            }
        });
        this.modalRef.close();
        this.aoActivarAdicaoArtigo.emit(true);
    }
}
